module.exports = __webpack_public_path__ + "static/media/houston_team.500e51b2.jpg";